import React from 'react'

import DatePickerButtons from './DatePickerButtons'
import DatePickerPresets from './DatePickerPresets'
import styles from './styles.less'

export default function DatePickerFooter({
  onApply,
  onCancel,
  onFocusChange,
  startOfReports,
  today,
}) {
  return (
    <div className={styles.DatePickerFooter}>
      <DatePickerPresets
        onApply={onApply}
        onFocusChange={onFocusChange}
        startOfReports={startOfReports}
        today={today}
      />
      <DatePickerButtons onApply={onApply} onCancel={onCancel} />
    </div>
  )
}
